// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nRy_","label":"styles_label__177l5"};